// extracted by mini-css-extract-plugin
module.exports = {"overlay":"overlay--HpSGg","icon":"icon--ba7rD","groupToggle":"groupToggle--3Mwtf"};